export default "__VITE_ASSET__636f3f23__"